export const WorkData = [
    {
        company:"The Machine Learning Company",
        designation:"Web Developement Intern",
        dateJoining:"Oct 2021",
        dateEnding:"Present",
        companyLogo:require("../../assets/Jobs/tmlc.png").default,
        work:"Working on enhancing the scalability of the website and making it responsive.",
    },
    {
        company:"Your Company Name",
        designation:"Web Developer",
        dateJoining:"Today",
        dateEnding:"",
        companyLogo:require("../../assets/work.png").default,
        work:"Currently looking for ReactJS centered role. Will be glad to work with you",
    },
]